import React from 'react'
import styled from 'styled-components'
import { ArrowRight, Minus, Plus } from 'sutra/components/Icons'
import { brand } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'
import { shadows } from 'sutra/tokens/shadows'

export interface CompareProps {
  oldItems: string[]
  newItems: string[]
  oldLabel?: string
  newLabel?: string
  className?: string
}

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px 1fr;
  gap: 16px;
  align-items: center;
`

const OldCard = styled.div`
  background: #f9f9f9;
  border-radius: ${radii.md}px;
  border: 1px solid #e9eaeb;
  padding: 24px;
  h3 {
    font-weight: 600;
    font-size: 18px;
    color: #717680;
    margin: 0 0 16px;
  }
`

const NewCard = styled.div`
  background: linear-gradient(
    135deg,
    ${brand.stillNight[50]} 0%,
    ${brand.white} 100%
  );
  border-radius: ${radii.md}px;
  border: 1px solid rgba(40, 54, 79, 0.22);
  padding: 24px;
  h3 {
    font-weight: 600;
    font-size: 18px;
    color: ${brand.stillNight[800]};
    margin: 0 0 16px;
  }
`

const Item = styled.div<{ $new?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 500;
  color: ${({ $new }) => ($new ? brand.stillNight[800] : '#717680')};
  &:last-child {
    margin-bottom: 0;
  }
`

const IconWrap = styled.span<{ $new?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: 1px;
  background: ${({ $new }) => ($new ? brand.stillNight[50] : '#E9EAEB')};
  color: ${({ $new }) => ($new ? brand.stillNight[800] : '#717680')};
`

const Arrow = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${brand.white};
  box-shadow: ${shadows.md};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${brand.stillNight[800]};
  flex-shrink: 0;
  justify-self: center;
`

export const Compare = ({
  oldItems,
  newItems,
  oldLabel = 'The old way',
  newLabel = 'The Yogi way',
  className,
}: CompareProps): React.ReactElement => (
  <Row className={className}>
    <OldCard>
      <h3>{oldLabel}</h3>
      {oldItems.map((item) => (
        <Item key={item}>
          <IconWrap>
            <Minus />
          </IconWrap>
          {item}
        </Item>
      ))}
    </OldCard>
    <Arrow>
      <ArrowRight />
    </Arrow>
    <NewCard>
      <h3>{newLabel}</h3>
      {newItems.map((item) => (
        <Item key={item} $new>
          <IconWrap $new>
            <Plus />
          </IconWrap>
          {item}
        </Item>
      ))}
    </NewCard>
  </Row>
)

Compare.displayName = 'Compare'
